var map = {
	"./dribbble.svg": 199,
	"./facebook.svg": 200,
	"./github.svg": 201,
	"./google.svg": 202,
	"./instagram.svg": 203,
	"./mailru.svg": 204,
	"./odnoklassniki.svg": 205,
	"./steam.svg": 206,
	"./telegram.svg": 207,
	"./twitch.svg": 208,
	"./twitter.svg": 209,
	"./vkontakte.svg": 210,
	"./wordpress.svg": 211,
	"./yahoo.svg": 212,
	"./yandex.svg": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;


//////////////////
// WEBPACK FOOTER
// ./src/img/socials ^\.\/.*\.svg$
// module id = 198
// module chunks = 0